<p>additional-options works!</p>
<app-post-purchase-navigation [target]="data.id"></app-post-purchase-navigation>
